/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWatchIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-watch"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.18 24Q9.53 24 9 23.61Q8.47 23.23 8.28 22.57L7.33 19.38Q7.13 18.73 6.76 18.07Q6.4 17.43 5.75 16.55Q5.03 15.6 4.64 14.44Q4.25 13.28 4.25 12Q4.25 10.78 4.64 9.63Q5.03 8.47 5.75 7.45Q6.45 6.47 6.79 5.85Q7.13 5.22 7.33 4.63L8.28 1.43Q8.47 0.78 9.01 0.39Q9.55 0 10.2 0L13.8 0Q14.45 0 14.99 0.39Q15.53 0.78 15.72 1.43L16.68 4.63Q16.88 5.28 17.24 5.92Q17.6 6.58 18.25 7.45Q18.98 8.4 19.36 9.56Q19.75 10.72 19.75 12Q19.75 13.22 19.36 14.38Q18.98 15.53 18.25 16.55Q17.55 17.52 17.21 18.15Q16.88 18.77 16.68 19.38L15.72 22.57Q15.53 23.23 14.99 23.61Q14.45 24 13.8 24ZM12 17.1Q12 17.1 13.06 17.1Q14.13 17.1 15.61 15.61Q17.1 14.13 17.1 12Q17.1 9.88 15.61 8.39Q14.13 6.9 12 6.9Q9.88 6.9 8.39 8.39Q6.9 9.88 6.9 12Q6.9 14.13 8.39 15.61Q9.88 17.1 12 17.1Z" fill={color} />
    </svg>
  );
}
